import type {I18nRuntime, TranslationValues} from "./index";
import type {JSX, ReactNode} from "react";

import {createContext, use} from "react";
import {useIntl} from "react-intl";

export {RawIntlProvider} from "react-intl";

interface I18nRuntimeProviderProps {
  children?: ReactNode;
  value: I18nRuntime;
}

const I18nRuntimeContext = createContext<I18nRuntime | null>(null);

export function I18nRuntimeProvider({children, value}: I18nRuntimeProviderProps): JSX.Element {
  return <I18nRuntimeContext value={value}>{children}</I18nRuntimeContext>;
}

export function useI18nRuntime(): I18nRuntime {
  const runtime = use(I18nRuntimeContext);

  if (!runtime) {
    throw new Error("useI18nRuntime must be used within I18nRuntimeProvider");
  }

  return runtime;
}

export function useI18n() {
  const runtime = useI18nRuntime();
  const intl = useIntl();

  const t = (descriptor: {id: string; defaultMessage?: string}, values?: TranslationValues) =>
    intl.formatMessage(descriptor, values);

  return {t, intl, runtime};
}
